// /src/pages/dashboard/accounts/AddAccountModal.js  (v2.0 – modernized UI)
import React, { useState } from 'react'
import { getPlatformIcon, getPlatformColor } from './helpers'

const PLATFORMS = [
  'Facebook', 'Instagram', 'X', 'LinkedIn',
  'Threads',  'TikTok',    'Pinterest', 'YouTube',
]

export default function AddAccountModal ({ show, onHide, handleConnectPlatform }) {
  const [hovered, setHovered] = useState(null)

  if (!show) return null

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onHide}
        style={{
          position      : 'fixed',
          inset         : 0,
          background    : 'rgba(0,0,0,0.4)',
          zIndex        : 1050,
          backdropFilter: 'blur(2px)',
        }}
      />

      {/* Modal panel */}
      <div style={{
        position     : 'fixed',
        top          : '50%',
        left         : '50%',
        transform    : 'translate(-50%, -50%)',
        zIndex       : 1051,
        background   : '#ffffff',
        borderRadius : 16,
        width        : 480,
        maxWidth     : 'calc(100vw - 32px)',
        boxShadow    : '0 20px 60px rgba(0,0,0,0.18)',
        overflow     : 'hidden',
      }}>

        {/* Header */}
        <div style={{
          display        : 'flex',
          alignItems     : 'center',
          justifyContent : 'space-between',
          padding        : '20px 24px 16px',
          borderBottom   : '1px solid #f3f4f6',
        }}>
          <div>
            <h3 style={{ fontSize: 17, fontWeight: 800, color: '#111827', margin: 0 }}>
              Connect a Social Account
            </h3>
            <p style={{ fontSize: 13, color: '#6b7280', margin: '4px 0 0' }}>
              Select a platform to connect to Greatly Social.
            </p>
          </div>
          <button
            onClick={onHide}
            style={{
              background    : 'transparent',
              border        : 'none',
              cursor        : 'pointer',
              width         : 30,
              height        : 30,
              borderRadius  : '50%',
              display       : 'flex',
              alignItems    : 'center',
              justifyContent: 'center',
              color         : '#9ca3af',
              fontSize      : 18,
              flexShrink    : 0,
            }}
          >
            ×
          </button>
        </div>

        {/* Platform grid */}
        <div style={{ padding: '20px 24px 24px' }}>
          <div style={{
            display              : 'grid',
            gridTemplateColumns  : 'repeat(4, 1fr)',
            gap                  : 12,
          }}>
            {PLATFORMS.map(platform => {
              const iconClass = getPlatformIcon(platform)
              const iconColor = getPlatformColor(platform)
              const isHovered = hovered === platform

              return (
                <button
                  key={platform}
                  type='button'
                  onClick={() => handleConnectPlatform(platform)}
                  onMouseEnter={() => setHovered(platform)}
                  onMouseLeave={() => setHovered(null)}
                  style={{
                    display       : 'flex',
                    flexDirection : 'column',
                    alignItems    : 'center',
                    gap           : 8,
                    padding       : '16px 8px',
                    borderRadius  : 12,
                    border        : `1.5px solid ${isHovered ? iconColor : '#e5e7eb'}`,
                    background    : isHovered ? `${iconColor}08` : '#fafafa',
                    cursor        : 'pointer',
                    transition    : 'all 0.15s ease',
                    outline       : 'none',
                  }}
                >
                  {/* Icon circle */}
                  <div style={{
                    width        : 44,
                    height       : 44,
                    borderRadius : '50%',
                    background   : `${iconColor}15`,
                    display      : 'flex',
                    alignItems   : 'center',
                    justifyContent: 'center',
                    transition   : 'transform 0.15s',
                    transform    : isHovered ? 'scale(1.08)' : 'scale(1)',
                  }}>
                    <i className={iconClass} style={{ fontSize: 20, color: iconColor }} />
                  </div>

                  {/* Label */}
                  <span style={{
                    fontSize  : 12,
                    fontWeight: 600,
                    color     : isHovered ? iconColor : '#374151',
                    transition: 'color 0.15s',
                  }}>
                    {platform}
                  </span>
                </button>
              )
            })}
          </div>
        </div>

        {/* Footer */}
        <div style={{
          padding       : '12px 24px 16px',
          borderTop     : '1px solid #f3f4f6',
          display       : 'flex',
          justifyContent: 'flex-end',
        }}>
          <button
            onClick={onHide}
            style={{
              padding     : '8px 18px',
              borderRadius: 8,
              border      : '1.5px solid #e5e7eb',
              background  : 'transparent',
              color       : '#374151',
              fontSize    : 13,
              fontWeight  : 600,
              cursor      : 'pointer',
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  )
}